"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityTypeEnum = exports.EventTypeEnum = exports.DataRequestTypeEnum = exports.DataResidencyEnum = void 0;
var DataResidencyEnum;
(function (DataResidencyEnum) {
    DataResidencyEnum["EU"] = "EU";
    DataResidencyEnum["US"] = "US";
    DataResidencyEnum["UAE"] = "UAE";
    DataResidencyEnum["AU"] = "AU";
    DataResidencyEnum["IN"] = "IN";
})(DataResidencyEnum = exports.DataResidencyEnum || (exports.DataResidencyEnum = {}));
var DataRequestTypeEnum;
(function (DataRequestTypeEnum) {
    DataRequestTypeEnum["SESSION"] = "SESSION";
    DataRequestTypeEnum["CLIENT"] = "CLIENT";
    DataRequestTypeEnum["EVENT"] = "EVENT";
})(DataRequestTypeEnum = exports.DataRequestTypeEnum || (exports.DataRequestTypeEnum = {}));
var EventTypeEnum;
(function (EventTypeEnum) {
    EventTypeEnum["APP_START"] = "APP_START";
    EventTypeEnum["CONTENT_VIEW"] = "CONTENT_VIEW";
    EventTypeEnum["CATEGORY_VIEW"] = "CATEGORY_VIEW";
    EventTypeEnum["PRODUCT_VIEW"] = "PRODUCT_VIEW";
    EventTypeEnum["CART_ADD"] = "CART_ADD";
    EventTypeEnum["LOOK_VIEW"] = "LOOK_VIEW";
    EventTypeEnum["CART_VIEW"] = "CART_VIEW";
    EventTypeEnum["CART_REMOVE"] = "CART_REMOVE";
    EventTypeEnum["SEARCH"] = "SEARCH";
    EventTypeEnum["SEARCH_CLEAR"] = "SEARCH_CLEAR";
    EventTypeEnum["CHECKOUT"] = "CHECKOUT";
    EventTypeEnum["PURCHASE"] = "PURCHASE";
    EventTypeEnum["QR_RUN"] = "QR_RUN";
    EventTypeEnum["CONTACT_IDENTIFY"] = "CONTACT_IDENTIFY";
    EventTypeEnum["CONTACT_METADATA"] = "CONTACT_METADATA";
    EventTypeEnum["DETECT_MOOD"] = "DETECT_MOOD";
    EventTypeEnum["DETECT_AGE"] = "DETECT_AGE";
    EventTypeEnum["DETECT_GENDER"] = "DETECT_GENDER";
    EventTypeEnum["RATING"] = "RATING";
    EventTypeEnum["CART_CLEAR"] = "CART_CLEAR";
    EventTypeEnum["FEEDBACK"] = "FEEDBACK";
})(EventTypeEnum = exports.EventTypeEnum || (exports.EventTypeEnum = {}));
var IdentityTypeEnum;
(function (IdentityTypeEnum) {
    IdentityTypeEnum["PHONE"] = "phone";
    IdentityTypeEnum["EMAIL"] = "email";
    IdentityTypeEnum["CLIENT_ID"] = "client_id";
    IdentityTypeEnum["OTHER"] = "other";
})(IdentityTypeEnum = exports.IdentityTypeEnum || (exports.IdentityTypeEnum = {}));
